import { useState, useEffect, useRef } from "react";
import { fetchFeedDataForGroups } from "../Utils/UGFetchFeeddata.js";
import { MoreButton } from "../../../../../UI-comp/ActionButtons.js";
import "../../../Styles/ua-common-styles.css";
import GroupMenuDropdown from "../Utils/GroupMenuDropdown.js";

// import "../../../Styles/ua-common-styles.css";
// import "../Styles/common-style.css";

const UGGridCentreUpperLayout = ({ renderOperation, setRenderOperation }) => {
  const [currentGroups, setCurrentGroups] = useState([]);
  const [suggestedGroups, setSuggestedGroups] = useState([]);
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [activeTab, setActiveTab] = useState("current");
  const moreButtonRef = useRef(null);


  // ✅ Menu items for selected friends
  // ✅ Updated menu items for groups
  const menuItems = [
    {
      label: "🏫 Create Group",
      action: () => {
        console.log("Creating new group");
        alert("Create New Group");
        setSelectedGroups([]);
      }
    },
    {
      label: "🔔 Mute Group",
      action: () => {
        if (selectedGroups.length === 0) {
          alert("Please select groups to mute");
          return;
        }
        console.log("Muting groups:", selectedGroups);
        alert(`Muted ${selectedGroups.length} group(s)`);
        setSelectedGroups([]);
      }
    },
    {
      label: "⭐ Mark as Favorite",
      action: () => {
        if (selectedGroups.length === 0) {
          alert("Please select groups to mark as favorite");
          return;
        }
        console.log("Marking as favorite:", selectedGroups);
        alert(`Marked ${selectedGroups.length} group(s) as favorite`);
        setSelectedGroups([]);
      }
    },
    {
      label: "👥 Invite Members",
      action: () => {
        if (selectedGroups.length === 0) {
          alert("Please select a group to invite members");
          return;
        }
        console.log("Inviting members to:", selectedGroups);
        alert("Invite Members");
        setSelectedGroups([]);
      }
    },
    {
      label: "🚪 Leave Group",
      action: () => {
        if (selectedGroups.length === 0) {
          alert("Please select groups to leave");
          return;
        }
        const confirmed = window.confirm(
          `Are you sure you want to leave ${selectedGroups.length} group(s)?`
        );
        if (confirmed) {
          console.log("Leaving groups:", selectedGroups);
          setCurrentGroups((prev) =>
            prev.filter((g) => !selectedGroups.includes(g.groupId))
          );
          setSelectedGroups([]);
        }
      }
    },
    {
      label: "🚨 Report Group",
      action: () => {
        if (selectedGroups.length === 0) {
          alert("Please select groups to report");
          return;
        }
        console.log("Reporting groups:", selectedGroups);
        alert(`Reported ${selectedGroups.length} group(s)`);
        setSelectedGroups([]);
      }
    },
  ];

  // ✅ Fetch groups on mount
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const data = await fetchFeedDataForGroups();
        setCurrentGroups(data.groupList || []);
        setSuggestedGroups(data.suggestedGroupList || []);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };
    fetchGroups();
  }, []);

  // ✅ Filter groups based on search query
  useEffect(() => {
    const groupsToFilter = activeTab === "current" ? currentGroups : suggestedGroups;
    
    if (searchQuery.trim() === "") {
      setFilteredGroups(groupsToFilter);
    } else {
      const filtered = groupsToFilter.filter((group) =>
        group.groupid?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        group.description?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredGroups(filtered);
    }
  }, [searchQuery, activeTab, currentGroups, suggestedGroups]);

  // ✅ Handle group selection
  const handleGroupSelect = (groupId) => {
    setSelectedGroups((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    );
  };

  const handleClearSelection = () => {
    setSelectedGroups([]);
  };

  const handleMoreOptionClick = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "0" }}>
      
      {/* ✅ MAIN CONTROL BAR - 20% LEFT | 60% CENTER | 20% RIGHT */}
      <div
        style={{
          display: "flex",
          // alignItems: "center",
          gap: "16px",
          padding: "16px 20px",
          justifyContent: "space-between",
          backgroundColor: "none",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
          background: "none"
        }}
      >
        {/* LEFT SECTION - 20% */}
        <div style={{ flex: "0 0 20%", minWidth: "150px" }}>
          {/* Empty or can add additional controls here */}
        </div>

        {/* CENTER SECTION - 60% - Tab Buttons */}
        <div
          style={{
            flex: "0 0 60%",
            display: "flex",
            gap: "12px",
            justifyContent: "flex-start",
            background: "none"
          }}
        >
          <span
            onClick={() => setActiveTab("current")}
            style={{
              padding: "16px 32px",
              fontSize: "13px",
              fontWeight: "600",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              backgroundColor: "rgba(255,255,255,0.1)",
              color: "white",
              whiteSpace: "nowrap",
              alignContent: "center",
              marginLeft: 0,
              height: 50, 
              marginTop: 10,
              border: "1px solid var(--border-color, rgb(52, 51, 51))"
            }}
          >
            Current Friends
          </span>

          <button
            onClick={() => setActiveTab("suggested")}
            style={{
              padding: "16px 32px",
              fontSize: "13px",
              fontWeight: "600",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              backgroundColor: "rgba(255,255,255,0.1)",
              color: "white",
              whiteSpace: "nowrap",
              marginLeft: 0,
              height: 50, 
              marginTop: 10,
              border: "1px solid var(--border-color, rgb(52, 51, 51))"
            }}
          >
            Suggested
          </button>

          {/* Search Bar */}
          <input
            type="text"
            placeholder="🔍 Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              flex: 1,
              padding: "16px 32px",
              borderRadius: "6px",
              border: "1px solid var(--border-color, rgb(52, 51, 51))",
              background: "rgba(255, 255, 255, 0.08)",
              color: "white",
              fontSize: "13px",
              outline: "none",
              transition: "all 0.3s ease",
              minWidth: "120px",
              height: 50, 
              marginTop: 10
            }}
          />
        </div>

        {/* RIGHT SECTION - 20% - More Button */}
        <div
          style={{
            flex: "0 0 20%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            position: "relative",
            marginLeft: -60,
            marginTop: 10

          }}
          ref={moreButtonRef}
        >
          <MoreButton
            onClick={handleMoreOptionClick}
            aria-label="More options"
            aria-expanded={menuOpen}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "6px",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              background: menuOpen ? "rgba(102, 126, 234, 0.2)" : "rgba(255, 255, 255, 0.08)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>
      </div>

      {/* Dropdown Menu */}
      <GroupMenuDropdown
        isOpen={menuOpen}
        onClose={handleCloseMenu}
        items={menuItems}
        className="custom-dropdown"
        anchorRef={moreButtonRef}
      />
    </div>
  );
};

export default UGGridCentreUpperLayout;
